import Vue from 'vue';
import { Config } from './Config';

class ConsoleHelperDefinition extends Vue {
    private get fullConsole(): boolean {
        return Config.InternalSettings !== null && Config.InternalSettings.FullConsole === 'true';
    }

    log(message?: any, ...optionalParams: any[]) {
        console.log(message, ...optionalParams);
    }
    
    warn(message?: any, ...optionalParams: any[]) {
        console.warn(message, ...optionalParams);
    }
    
    debugLog(message?: any, ...optionalParams: any[]) {
        if (this.fullConsole) {
            console.log(message, ...optionalParams);
        }
        // tslint:disable-next-line:no-empty
        return () => { };
    }
    
    debugWarn(message?: any, ...optionalParams: any[]) {
        if (this.fullConsole) {
            console.warn(message, ...optionalParams);
        }
        // tslint:disable-next-line:no-empty
        return () => { };
    }
}

export const Consoler = new ConsoleHelperDefinition();